import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import NewAppointment from "./NewAppointment";

// Defined at module scope so it keeps a stable component identity across
// the parent's re-renders — otherwise React treats it as a brand-new
// component type on every render and remounts the Offcanvas, visibly
// flickering it open/closed while the parent's post-mount data fetches land.
const AppointmentSidebar = ({
  show,
  onHide,
  canvasType,
  editGroupId,
  selectedDate,
}) => {
  const [formData, setFormData] = useState({
    service: "",
    doctor: "",
    mobile: "",
    name: "",
    age: "",
    gender: "Male",
    membership: "",
    court: "",
    date: selectedDate,
    time: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    console.log("Appointment Data 👉", formData);
    onHide();
  };

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="end"
      backdrop={true}
      style={{ width: "500px" }}
    >
      <Offcanvas.Header closeButton className="custom-border-bottom p-4">
        <Offcanvas.Title className="page-heading">
          {canvasType === "new" ? "New Appointment" : ""}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0 d-flex flex-column">
        <div className="appointment-card">
          <div className="appointment-body">
            <NewAppointment
              onClose={onHide}
              mode={canvasType === "edit" ? "edit" : "new"}
              groupId={canvasType === "edit" ? editGroupId : undefined}
            />
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AppointmentSidebar;
